import { Route } from "react-router-dom";

import { queryClient } from "@/providers/QueryClient";
import { loadSearchTablePreferences } from "@/shared/domain/config/loaders/loadSearchTablePreferences";

import { File } from "./File";
import { FilesPage } from "./FilesPage";

const filesListLoader = loadSearchTablePreferences(
  queryClient,
  "file_search_table_preferences",
);

export const FilesRoutes = () => [
  <Route key="/" index loader={filesListLoader} element={<FilesPage />} />,
  <Route
    key="detail"
    path=":fileId/:workspaceId?"
    loader={File.loader(queryClient)}
    element={<File.Component />}
    errorElement={<File.ErrorBoundary />}
  />,
];
